import { render, staticRenderFns } from "./customer-contact.vue?vue&type=template&id=438bb1c0&scoped=true"
import script from "./customer-contact.vue?vue&type=script&lang=js"
export * from "./customer-contact.vue?vue&type=script&lang=js"
import style0 from "./customer-contact.vue?vue&type=style&index=0&id=438bb1c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438bb1c0",
  null
  
)

export default component.exports